import { all, call, put, fork, takeEvery } from "redux-saga/effects";

import {
  KITS_BYPATIENT_GET_LIST,
  KITS_USER_GET_LIST,
  KITS_BYDOCTOR_GET_LIST,
  KIT_GET_INFO,
  KIT_ADD_ITEM,
  KIT_EDIT_ITEM,
  KIT_UNLOCK_PLUGIN_ITEM,
  KIT_ACTIVATE_ITEM,
  KIT_GET_RESULTS,
  KIT_GET_RESULTS_BEHAVIOUR,
  KIT_GET_RESULTS_BIOMARKERS,
  KITS_GET_RESULTS_TIMECOURSE,
  KIT_REMOVE_ITEM,
  KIT_GET_UPLOADED_DATA,
  KIT_REMOVE_UPLOADED_DATA,
  KIT_TAKEACTION_EDIT_ITEM,
  KIT_RESULTS_COMMENTS_EDIT_ITEM,
  KIT_TAKEACTION_REMOVE_ITEM,
  KIT_REPORT_GET_LOGO,
  KIT_REPORT_EDIT_LOGO,
  KIT_CLEAR_DATA,
  KITS_BYPATIENT_LIST_CLEAR_DATA,
  KITS_RESULTS_CLEAR_DATA,
  KITS_RESULTS_TIMECOURSE_CLEAR_DATA,
} from "../actions";

import {
  getKitsPerPatientListSuccess,
  getKitsPerPatientListError,
  getKitsPerUserListSuccess,
  getKitsPerUserListError,
  getKitsByDoctorListSuccess,
  getKitsByDoctorListError,
  getKitInfoSuccess,
  getKitInfoError,
  addKitItemSuccess,
  addKitItemError,
  editKitItemSuccess,
  editKitItemError,
  unlockPluginItemSuccess,
  unlockPluginItemError,
  activateKitItemSuccess,
  activateKitItemError,
  getKitResultsSuccess,
  getKitResultsError,
  getKitResultsBehaviourSuccess,
  getKitResultsBehaviourError,
  getKitResultsBiomarkersSuccess,
  getKitResultsBiomarkersError,
  getKitsResultsTimecourseSuccess,
  getKitsResultsTimecourseError,
  removeKitItemSuccess,
  removeKitItemError,
  getKitUploadedDataSuccess,
  getKitUploadedDataError,
  removeKitUploadedDataSuccess,
  removeKitUploadedDataError,
  editKitResultsTakeActionItemSuccess,
  editKitResultsTakeActionItemError,
  editKitResultsCommentsItemSuccess,
  editKitResultsCommentsItemError,
  removeKitResultsTakeActionItemSuccess,
  removeKitResultsTakeActionItemError,
  getReportLogoSuccess,
  getReportLogoError,
  editReportLogoItemSuccess,
  editReportLogoItemError,
} from "./actions";

import queryString from "query-string"; // import the queryString class
import moment from "moment";

//!1. Our worker saga

//* GET LIST KITS per Patient // -----------------------------------------------------
const getKitsPerPatientListRequest = async (payload) => {
  //console.log(payload);
  //console.log(payload.payload);
  let patientId = payload.payload;

  return await fetch(`/mick/patients/${patientId}/experiments?archived=0`, {
    method: "get",
    credentials: "include", // add the cookie to the header
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      return data.data;
    })
    .catch((error) => console.error(error));
};

function* getKitsPerPatientList(payload) {
  // payload will be the username from the component
  //console.log(payload);

  try {
    const response = yield call(getKitsPerPatientListRequest, payload);
    //console.log(response);

    yield put(getKitsPerPatientListSuccess(response));
  } catch (error) {
    yield put(getKitsPerPatientListError(error));
  }
}

//* GET LIST KITS per User // -----------------------------------------------------

const getKitsPerUserListRequest = async (payload) => {
  //console.log(payload);
  //console.log(payload.payload);
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/experiments?archived=0`, {
    method: "get",
    credentials: "include", // add the cookie to the header
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      return data.data;
    })
    .catch((error) => console.error(error));
};

function* getKitsPerUserList(payload) {
  // payload will be the username from the component
  // console.log(payload);

  try {
    const response = yield call(getKitsPerUserListRequest, payload);
    //console.log(response);

    yield put(getKitsPerUserListSuccess(response));
  } catch (error) {
    yield put(getKitsPerUserListError(error));
  }
}

//* GET LIST KITS per Doctor // -----------------------------------------------------

const getKitsByDoctorListRequest = async (payload) => {
  //console.log(payload);
  //console.log(payload.payload);
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/experiments?archived=0`, {
    method: "get",
    credentials: "include", // add the cookie to the header
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      return data.data;
    })
    .catch((error) => console.error(error));
};

function* getKitsByDoctorList(payload) {
  // payload will be the username from the component
  //console.log(payload);

  try {
    const response = yield call(getKitsByDoctorListRequest, payload);
    //console.log(response);

    yield put(getKitsByDoctorListSuccess(response));
  } catch (error) {
    yield put(getKitsByDoctorListError(error));
  }
}

//* GET INFO KIT // -----------------------------------------------------

const getKitInfoRequest = async (payload) => {
  //console.log(payload);
  //console.log(payload.payload);
  let experimentId = payload.payload;

  return await fetch(`/mick/experiments/${experimentId}/info`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getKitInfo(payload) {
  // payload will be the experiment ID
  console.log(payload);

  try {
    const response = yield call(getKitInfoRequest, payload);
    console.log("success");
    yield put(getKitInfoSuccess(response[0]));
  } catch (error) {
    yield put(getKitInfoError(error));
  }
}

//* ADD KIT // -----------------------------------------------------
const addKitItemRequest = async (payload) => {
  console.log(payload);
  var {
    //* GENERAL
    patientId, //string
    needTube, //boolean
    key, //string
    target, //string
    source, //Sample type
    type, //Sequencing method
    technology, // Sequencing technology
    comments, //string
    uploadFastq, //boolean
    regex, //string
    plugins, //array

    //* GUT
    intolerances,
    height, //float number
    weight, //float number
    diet,
    foodExeptions,
    fiber,
    stoolType,
    drugs,
    drugTypes,
    probiotics,
    probioticsTypes,
    smokeHabit,
    alcoholHabit,
    dietRecall,
    threeDaysDietRecall,
    autismSeveritySocial,
    autismSeverityBehaviors,

    //* VAGINA
    hormonalCondition, //string
    regularMenstruation, //string
    heavyMenstruation, //string
    menstruationDays, //number
    pregnancy, //boolean
    pregnancyDuration, //number
    uid, //boolean
    uidType, //string
    oralContraceptive, //boolean
    oralContraceptiveType, //string
    recurrentInfections, //boolean
    recurrentInfectionsDescription, //string
    symptoms, //list
    papiloma, //boolean
    papilomaVirusType, //string
    papilomaVirusTreatment, //string
    otherVaginalInfections, //list

    //* EYES
    anesthetic, //boolean
    antibiotic, //boolean
    ocularDiseases, //list
  } = payload;

  // // working on plugins
  // var today = moment().format("DD/MM/YYYY");
  // var pluginsActivated = plugins.reduce(function (s, a, i) {
  //   s.push({
  //     name: a,
  //     date: today,
  //   });
  //   return s;
  // }, []);

  // console.log(pluginsActivated);

  // var formBodyPlugins = queryString.stringify(pluginsData, {
  //   arrayFormat: "bracket",
  //   skipNull: true,
  // });

  // var pluginsData = {
  //   plugins: pluginsActivated,
  // };

  // console.log(pluginsData);

  // var JSONplugins = JSON.stringify(plugins, {
  //   arrayFormat: "bracket",
  //   skipNull: true,
  // });

  // console.log(JSONplugins);

  // console.log(
  //   queryString.stringify(
  //     {
  //       plugin: ["name", "date"],
  //     },
  //     {
  //       arrayFormat: "bracket",
  //       skipNull: true,
  //     }
  //   )
  // );

  // const serialize = function (obj, prefix) {
  //   var str = [],
  //     p;
  //   for (p in obj) {
  //     if (obj.hasOwnProperty(p)) {
  //       var k = prefix ? prefix + "[" + p + "]" : p,
  //         v = obj[p];
  //       str.push(
  //         v !== null && typeof v === "object"
  //           ? serialize(v, k)
  //           : encodeURIComponent(k) + "=" + encodeURIComponent(v)
  //       );
  //     }
  //   }
  //   return str.join("&");
  // };

  // console.log(serialize(pluginsActivated));

  //console.log(JSON.stringify(pluginsActivated));

  //var formBodyPlugins = serialize(pluginsActivated);

  //* GENERAL

  var generalData = {
    patientId,
    needTube, //boolean
    key, //string
    source, //string
    target, //string
    type, // string
    technology, // string
    uploadFastq, //boolean
    regex, // string
    kitComments: comments, // string
    plugins: plugins, // array
  };

  console.log(generalData);

  // using queryString module
  var formBodyGeneralData = queryString.stringify(generalData, {
    arrayFormat: "bracket",
    skipNull: true,
  });

  var body;

  console.log("source", source);

  if (target.toLowerCase() === "gut") {
    console.log("INSIDE FAECES SAGA");

    //* GUT
    var doEat;
    var doNotEat;
    console.log("1");
    if (!foodExeptions) {
      doEat = [];
      doNotEat = [];
    } else {
      doEat = payload.doEat.map((item) => item.value);
      doNotEat = payload.doNotEat.map((item) => item.value);
    }
    console.log("2");
    if (!drugs) {
      drugTypes = [];
    }
    if (!probiotics) {
      probioticsTypes = [];
    }
    console.log("3");
    var gutData = {
      intolerances, //array
      height, //float number
      weight, //float number
      diet, //array
      doEat, //array
      doNotEat, //array
      fiber, //array
      bsc: stoolType, // number
      drugs, //boolean
      drugTypes, //array
      probiotics, //boolean
      probioticsTypes, //array
      smoke: smokeHabit, //string
      alcohol: alcoholHabit, //string
      recallBool: dietRecall, //boolean
      autismSeveritySocial, // number
      autismSeverityBehaviors, // number
    };

    var gutDataRecall;

    if (!dietRecall) {
      gutDataRecall = {
        recall1: ["", "", "", "", ""],
        recall2: ["", "", "", "", ""],
        recall3: ["", "", "", "", ""],
      };
    } else {
      gutDataRecall = {
        recall1: [
          Object.values(threeDaysDietRecall["day1"]).map((meal) => `${meal}`),
        ],
        recall2: [
          Object.values(threeDaysDietRecall["day2"]).map((meal) => `${meal}`),
        ],
        recall3: [
          Object.values(threeDaysDietRecall["day3"]).map((meal) => `${meal}`),
        ],
      };
    }

    console.log(gutData, gutDataRecall);
    //* GUT
    var formBodyGutData = queryString.stringify(gutData, {
      arrayFormat: "bracket",
      skipNull: true,
    });
    var formBodyGutDataRecall = queryString.stringify(gutDataRecall, {
      arrayFormat: "bracket",
      skipNull: true,
    });

    body =
      formBodyGeneralData + "&" + formBodyGutData + "&" + formBodyGutDataRecall;
  } else if (target.toLowerCase() === "vagina") {
    console.log("INSIDE VAGINA SAGA");
    //* VAGINA

    var vaginaData = {
      hormonalCondition, //string
      regularMenstruation, //string
      heavyMenstruation, //string
      menstruationDays, //number
      pregnancy, //boolean
      pregnancyDuration, //number
      uid, //boolean
      uidType, //string
      oralContraceptive, //boolean
      oralContraceptiveType, //string
      recurrentInfections, //boolean
      recurrentInfectionsDescription, //string
      symptoms, //list
      papiloma, //boolean
      papilomaVirusType, //string
      papilomaVirusTreatment, //string
      otherVaginalInfections, //list
    };

    var formBodyVaginaData = queryString.stringify(vaginaData, {
      arrayFormat: "bracket",
      skipNull: true,
    });

    console.log(formBodyVaginaData);

    body = formBodyGeneralData + "&" + formBodyVaginaData;
  } else if (target.toLowerCase() === "eye") {
    //* EYES
    var eyesData = {
      anesthetic, //boolean
      antibiotic, //boolean
      infections: ocularDiseases, //list
    };

    var formBodyEyesData = queryString.stringify(eyesData, {
      arrayFormat: "bracket",
      skipNull: true,
    });

    body = formBodyGeneralData + "&" + formBodyEyesData;
  }

  console.log(body);

  return await fetch(`/mick/experiments/add/`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      Accept: "application/x-www-form-urlencoded",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  })
    .then((response) => {
      //console.log(response);
      return response.json();
    })
    .then((data) => {
      console.log(data);
      return data;
    });
  // .then((response) => {
  //   console.log(response);
  //   return response.text();
  // })
  // .then((response) => {
  //   console.log(response);
  //   return response;
  // });
};

function* addKitItem(payload) {
  //console.log(payload);
  try {
    const response = yield call(addKitItemRequest, payload.payload);
    console.log(response);
    if (response.status === "success") {
      yield put(addKitItemSuccess(response));
    } else {
      //console.log(response);
      yield put(
        addKitItemError(
          response.info
          //"KIT already present into the database. Check if the KIT is already assigned to the patient."
        )
      );
    }
  } catch (error) {
    yield put(addKitItemError(error.message));
  }
}

//* EDIT KIT INFO // -----------------------------------------------------

const editKitItemRequest = async (payload) => {
  var {
    //* GENERAL
    experimentId, //string
    patientId, //string
    needTube, //boolean
    key, //string
    target, //string
    source, //Sample type
    type, //Sequencing method
    status, //number
    technology, // Sequencing technology
    comments, //string
    uploadFastq, //boolean
    regex, //string
    plugins, //array

    //* GUT
    intolerances,
    height, //float number
    weight, //float number
    diet,
    foodExeptions,
    fiber,
    stoolType,
    drugs, // boolean
    drugTypes,
    probiotics, // boolean
    probioticsTypes,
    smokeHabit,
    alcoholHabit,
    dietRecall,
    breakfastDay1,
    snack1Day1,
    lunchDay1,
    snack2Day1,
    dinnerDay1,
    breakfastDay2,
    snack1Day2,
    lunchDay2,
    snack2Day2,
    dinnerDay2,
    breakfastDay3,
    snack1Day3,
    lunchDay3,
    snack2Day3,
    dinnerDay3,

    //* VAGINA
    hormonalCondition, //string
    regularMenstruation, //string
    heavyMenstruation, //string
    menstruationDays, //number
    pregnancy, //boolean
    pregnancyDuration, //number
    uid, //boolean
    uidType, //string
    oralContraceptive, //boolean
    oralContraceptiveType, //string
    recurrentInfections, //boolean
    recurrentInfectionsDescription, //string
    symptoms, //list
    papiloma, //boolean
    papilomaVirusType, //string
    papilomaVirusTreatment, //string
    otherVaginalInfections, //list

    //* EYES
    anesthetic, //boolean
    antibiotic, //boolean
    ocularDiseases, //list
  } = payload;

  // var JSONplugins = JSON.stringify(plugins, {
  //   arrayFormat: "bracket",
  //   skipNull: true,
  // });

  // console.log(JSONplugins);

  var body;

  //? I'm using this function and not the npm module stringify as done for add-forms (in edit form the body is sent in a different way)
  // function getQueryStringObjectType(params) {
  //   return Object.keys(params)
  //     .map((k) => {
  //       // if found an array
  //       if (Array.isArray(params[k])) {
  //         return `"${encodeURIComponent(k)}":[${
  //           typeof params[k] == "string"
  //             ? params[k].map((val) => `"${encodeURIComponent(val)}"`).join(",")
  //             : typeof params[k] === "object"
  //             ? Object.keys(params[k])
  //                 .map((val) => {
  //                   return `"${encodeURIComponent(
  //                     params[k][val]
  //                   )}":"${encodeURIComponent(params[k][val])}"`;
  //                 })
  //                 .join(",")
  //             : null
  //         }]`;
  //       }

  //       // if found a number or a boolean doesn't add brackets
  //       if (typeof params[k] == "number" || typeof params[k] == "boolean") {
  //         return `"${encodeURIComponent(k)}":${encodeURIComponent(params[k])}`;
  //       }
  //       // for common strings
  //       return `"${encodeURIComponent(k)}":"${encodeURIComponent(params[k])}"`;
  //     })
  //     .join(",");
  // }

  // const object = {
  //   key: "T1611160045202",
  //   array: ["test1", "test2"],
  //   plugins: [
  //     {
  //       name: "Plugin 16S Nutrition",
  //       processed: false,
  //     },
  //     {
  //       name: "Plugin 16S Health",
  //       processed: false,
  //     },
  //   ],
  //   source: "faeces",
  //   status: 0,
  // };

  // function getQueryStringObjectType(object) {
  //   return Object.keys(object)
  //     .map((key) => {
  //       // if found an array
  //       if (Array.isArray(object[key])) {
  //         return ` "${encodeURIComponent(key)}":[${object[key].map((val) =>
  //           // if is an array of strings
  //           typeof val === "string"
  //             ? `"${encodeURIComponent(val)}"`
  //             : // if is an array of objects
  //             typeof val === "object"
  //             ? Object.keys(val)
  //                 .map((keyVal) => {
  //                   return `{"${encodeURIComponent(keyVal)}": ${
  //                     typeof val[keyVal] === "number" ||
  //                     typeof val[keyVal] === "boolean"
  //                       ? `${encodeURIComponent(val[keyVal])}`
  //                       : `"${encodeURIComponent(val[keyVal])}"`
  //                   } `;
  //                 })
  //                 .join(",")
  //             : null
  //         )}]`;
  //       }

  //       // if found a number or a boolean doesn't add brackets
  //       if (
  //         typeof object[key] === "number" ||
  //         typeof object[key] === "boolean"
  //       ) {
  //         return `"${encodeURIComponent(key)}":${encodeURIComponent(
  //           object[key]
  //         )}`;
  //       }
  //       // for common strings
  //       return `"${encodeURIComponent(key)}":"${encodeURIComponent(
  //         object[key]
  //       )}"`;
  //     })
  //     .join(",");
  // }

  // function getQueryStringObjectType(object) {
  //   return Object.keys(object)
  //     .map((key) => {
  //       // if found an array
  //       if (Array.isArray(object[key])) {
  //         return ` "${encodeURIComponent(key)}":[${object[key].map((val) =>
  //           // if is an array of strings
  //           typeof val === "string"
  //             ? `"${encodeURIComponent(val)}"`
  //             : // if is an array of objects
  //             typeof val === "object"
  //             ? Object.keys(val)
  //                 .map((keyVal) => {
  //                   return `{"${encodeURIComponent(
  //                     keyVal
  //                   )}":"${encodeURIComponent(val[keyVal])}"}`;
  //                 })
  //                 .join(",")
  //             : null
  //         )}]`;
  //       }

  //       // if found a number or a boolean doesn't add brackets
  //       if (
  //         typeof object[key] === "number" ||
  //         typeof object[key] === "boolean"
  //       ) {
  //         return `"${encodeURIComponent(key)}":${encodeURIComponent(
  //           object[key]
  //         )}`;
  //       }
  //       // for common strings
  //       return `"${encodeURIComponent(key)}":"${encodeURIComponent(
  //         object[key]
  //       )}"`;
  //     })
  //     .join(",");
  // }

  // const decod = getQueryStringObjectType(object);

  // console.log(decod);

  // console.log(JSON.stringify(object));

  //* GENERAL

  // console.log(plugins);

  // var today = moment().format("DD/MM/YYYY");
  // var pluginsActivated = plugins.reduce(function (s, a, i) {
  //   s.push({
  //     name: a,
  //     date: today,
  //   });
  //   return s;
  // }, []);

  var formBodyGeneralData = {
    patientId,
    needTube, //boolean
    key, //string
    target, //string
    source, //string
    type, // string
    status, //number
    technology, // string
    uploadFastq, //boolean
    "metadata.comments": comments, // string
    "metadata.regex": regex, // string
    plugins: plugins, //array
  };

  //formBodyGeneralData = getQueryStringObjectType(formBodyGeneralData);

  formBodyGeneralData = JSON.stringify(formBodyGeneralData);

  console.log(formBodyGeneralData);

  console.log("source", source);
  console.log("target", target);

  if (target.toLowerCase() === "gut") {
    console.log("INSIDE FAECES SAGA");

    //* GUT
    var doEat = payload.doEat.map((item) => item.value);
    var doNotEat = payload.doNotEat.map((item) => item.value);

    if (!foodExeptions) {
      doEat = [];
      doNotEat = [];
    }
    if (!drugs) {
      drugTypes = [];
    }
    if (!probiotics) {
      probioticsTypes = [];
    }

    var recall1 = [
      breakfastDay1,
      snack1Day1,
      lunchDay1,
      snack2Day1,
      dinnerDay1,
    ];
    var recall2 = [
      breakfastDay2,
      snack1Day2,
      lunchDay2,
      snack2Day2,
      dinnerDay2,
    ];
    var recall3 = [
      breakfastDay3,
      snack1Day3,
      lunchDay3,
      snack2Day3,
      dinnerDay3,
    ];
    var formBodyGutData = {
      "metadata.height": height,
      "metadata.weight": weight,
      "metadata.diet": diet,
      "metadata.fiberHabit": fiber,
      "metadata.bsc": stoolType,
      "metadata.drugs": drugs,
      "metadata.probiotics": probiotics,
      "metadata.smokeHabit": smokeHabit,
      "metadata.alcoholHabit": alcoholHabit,
      "metadata.recallBool": dietRecall,
      "metadata.intolerances": intolerances,
      "metadata.drugTypes": drugTypes,
      "metadata.probioticsTypes": probioticsTypes,
      "metadata.doEat": doEat,
      "metadata.doNotEat": doNotEat,
      "metadata.recall.1": recall1,
      "metadata.recall.2": recall2,
      "metadata.recall.3": recall3,
    };

    //formBodyGutData = getQueryStringObjectType(formBodyGutData);

    formBodyGutData = JSON.stringify(formBodyGutData);

    console.log(formBodyGutData.substring(1).slice(0, -1));

    body = `experimentId=${experimentId}&toBeModified={${formBodyGeneralData
      .substring(1)
      .slice(0, -1)}, ${formBodyGutData.substring(1).slice(0, -1)}}`;
  } else if (target.toLowerCase() === "vagina") {
    console.log("INSIDE VAGINA SAGA");
    //* VAGINA

    if (!pregnancy) {
      pregnancyDuration = "";
    }
    if (!uid) {
      uidType = "";
    }
    if (!oralContraceptive) {
      oralContraceptiveType = "";
    }
    if (!recurrentInfections) {
      recurrentInfectionsDescription = "";
    }
    if (!papiloma) {
      papilomaVirusType = "";
      papilomaVirusTreatment = "";
    }

    var formBodyVaginaData = {
      "metadata.hormonalCondition": hormonalCondition, //string
      "metadata.regularMenstruation": regularMenstruation, //string
      "metadata.heavyMenstruation": heavyMenstruation, //string
      "metadata.menstruationDays": menstruationDays, //number
      "metadata.pregnancy": pregnancy, //boolean
      "metadata.pregnancyDuration": pregnancyDuration, //number
      "metadata.uid": uid, //boolean
      "metadata.uidType": uidType, //string
      "metadata.oralContraceptive": oralContraceptive, //boolean
      "metadata.oralContraceptiveType": oralContraceptiveType, //string
      "metadata.recurrentInfections": recurrentInfections, //boolean
      "metadata.recurrentInfectionsDescription": recurrentInfectionsDescription, //string
      "metadata.symptoms": symptoms, //list/array
      "metadata.papiloma": papiloma, //boolean
      "metadata.papilomaVirusType": papilomaVirusType, //string
      "metadata.papilomaVirusTreatment": papilomaVirusTreatment, //string
      "metadata.otherVaginalInfections": otherVaginalInfections, //list/array
    };

    //formBodyVaginaData = getQueryStringObjectType(formBodyVaginaData);
    formBodyVaginaData = JSON.stringify(formBodyVaginaData);
    // symptoms = getObject(symptoms);
    //otherVaginalInfections = getObject(otherVaginalInfections);
    //    body = `experimentId=${experimentId}&toBeModified={${formBodyGeneralData}, ${formBodyVaginaData}, "metadata.symptoms": [${symptoms}], "metadata.otherVaginalInfections": [${otherVaginalInfections}] }`;

    body = `experimentId=${experimentId}&toBeModified={${formBodyGeneralData
      .substring(1)
      .slice(0, -1)}, ${formBodyVaginaData.substring(1).slice(0, -1)}}`;
  } else if (target.toLowerCase() === "eye") {
    //* EYES
    var formBodyEyesData = {
      "metadata.anesthetic": anesthetic, //boolean
      "metadata.antibiotic": antibiotic, //boolean
      "metadata.infections": ocularDiseases, //list
    };

    //formBodyEyesData = getQueryStringObjectType(formBodyEyesData);
    formBodyEyesData = JSON.stringify(formBodyEyesData);

    body = `experimentId=${experimentId}&toBeModified={${formBodyGeneralData
      .substring(1)
      .slice(0, -1)}, ${formBodyEyesData.substring(1).slice(0, -1)}}`;
  }

  console.log(body);

  return await fetch(`/mick/experiments/modify/`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      //Accept: "application/x-www-form-urlencoded",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  })
    .then((response) => {
      //console.log(response);
      return response.text();
    })
    .then((response) => {
      //console.log(response);
      return response;
    });
};

function* editKitItem(payload) {
  //console.log(payload);
  try {
    const response = yield call(editKitItemRequest, payload.payload);
    //console.log(response);
    if (!response.includes("ERROR")) {
      yield put(editKitItemSuccess(response));
    } else {
      //console.log(response.status);
      yield put(editKitItemError(response));
    }
  } catch (error) {
    yield put(editKitItemError(error));
  }
}

//* UNLOCK PLUGIN // -----------------------------------------------------

const unlockPluginItemRequest = async (payload) => {
  var {
    experimentId, //string
    plugins,
    type,
  } = payload;

  var generalData = {
    plugins,
    type,
  };

  var data = JSON.stringify(generalData);

  var body = `experimentId=${experimentId}&toBeModified=${data}`;

  console.log(body);

  return await fetch(`/mick/experiments/modify/`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      //Accept: "application/x-www-form-urlencoded",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  })
    .then((response) => {
      //console.log(response);
      return response.text();
    })
    .then((response) => {
      //console.log(response);
      return response;
    });
};

function* unlockPluginItem(payload) {
  console.log(payload);
  try {
    const response = yield call(unlockPluginItemRequest, payload.payload);
    //console.log(response);
    if (!response.includes("ERROR")) {
      yield put(unlockPluginItemSuccess(response));
    } else {
      //console.log(response.status);
      yield put(unlockPluginItemError(response));
    }
  } catch (error) {
    yield put(unlockPluginItemError(error));
  }
}

//* ACTIVATE KIT // -----------------------------------------------------
const activateKitItemRequest = async (payload) => {
  //console.log("inside addKitItemRequest");
  //console.log(payload);
  const { patientSurname, kitKey } = payload;
  return await fetch(`/mick/experiments/activate`, {
    method: "post",
    //credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      Accept: "application/x-www-form-urlencoded",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: `surname=${patientSurname}&key=${kitKey}`,
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* activateKitItem(payload) {
  //console.log(payload);
  try {
    const response = yield call(activateKitItemRequest, payload.payload);
    //console.log(response);
    if (!response.includes("ERROR")) {
      yield put(activateKitItemSuccess(response));
    } else {
      // console.log(response.status);
      yield put(activateKitItemError(response));
    }
  } catch (error) {
    yield put(activateKitItemError(error));
  }
}

//* GET RESULTS KIT // -----------------------------------------------------

const getKitResultsRequest = async (payload) => {
  console.log(payload);
  // console.log(payload.payload);
  let { experimentId, language } = payload.payload;

  return await fetch(
    `/mick/experiments/${experimentId}/results?lang=${language}`,
    {
      method: "get",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Origin": "https://35.189.226.137",
      },
    }
  )
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getKitResults(payload) {
  // payload will be the experiment ID
  console.log(payload);

  try {
    const response = yield call(getKitResultsRequest, payload);
    // console.log("response");
    yield put(getKitResultsSuccess(response));
  } catch (error) {
    console.log("error");
    yield put(getKitResultsError(error));
  }
}

//* GET RESULTS KIT BEHAVIOUR // -----------------------------------------------------

const getKitResultsBehaviourRequest = async (payload) => {
  //console.log(payload);
  let username = payload.payload;
  return await fetch(`/mick/behaviour/${username}`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getKitResultsBehaviour(payload) {
  // payload will be the experiment ID
  //console.log(payload);

  try {
    const response = yield call(getKitResultsBehaviourRequest, payload);
    // console.log("success");
    yield put(getKitResultsBehaviourSuccess(response));
  } catch (error) {
    yield put(getKitResultsBehaviourError(error));
  }
}

//* GET RESULTS KIT BIOMARKERS // -----------------------------------------------------

const getKitResultsBiomarkersRequest = async () => {
  return await fetch(`/mick/biomarkers`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getKitResultsBiomarkers() {
  try {
    const response = yield call(getKitResultsBiomarkersRequest);
    // console.log("success");
    yield put(getKitResultsBiomarkersSuccess(response));
  } catch (error) {
    yield put(getKitResultsBiomarkersError(error));
  }
}

//* GET RESULTS KITS TIMECOURSE // -----------------------------------------------------

const getKitsResultsTimecourseRequest = async (payload) => {
  console.log(payload.payload);
  let experimentIds = payload.payload.items;

  console.log(experimentIds);

  return await fetch(
    `/mick/experiments/timecourse?experimentIds=${experimentIds}`,
    {
      method: "get",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Origin": "https://35.189.226.137",
      },
    }
  )
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getKitsResultsTimecourse(payload) {
  try {
    const response = yield call(getKitsResultsTimecourseRequest, payload);
    // console.log("success");
    yield put(
      getKitsResultsTimecourseSuccess({
        response,
        target: payload.payload.target,
      })
    );
  } catch (error) {
    yield put(getKitsResultsTimecourseError(error));
  }
}

//* REMOVE KIT //--------------------------------------------------------
const removeKitItemRequest = async (payload) => {
  console.log(payload.payload);
  let experimentId = payload.payload;

  return await fetch(`/mick/experiments/${experimentId}/remove`, {
    method: "delete",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* removeKitItem(payload) {
  // payload will contain the ID of the experiment
  console.log(payload);

  try {
    const response = yield call(removeKitItemRequest, payload);
    if (!response.includes("ERROR")) {
      yield put(removeKitItemSuccess(response));
    } else {
      yield put(removeKitItemError(response));
    }
  } catch (error) {
    yield put(activateKitItemError(error));
  }
}

//* GET UPLOADED DATA KIT // -----------------------------------------------------

const getKitUploadedDataRequest = async (payload) => {
  //console.log(payload);
  // console.log(payload.payload);
  let experimentId = payload.payload;

  return await fetch(`/mick/experiments/${experimentId}/uploads`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getKitUploadedData(payload) {
  // payload will be the experiment ID
  //console.log(payload);

  try {
    const response = yield call(getKitUploadedDataRequest, payload);
    // console.log("success");
    yield put(getKitUploadedDataSuccess(response));
  } catch (error) {
    yield put(getKitUploadedDataError(error));
  }
}

//* DELETE UPLOADED DATA KIT // -----------------------------------------------------
const removeKitUploadedDataRequest = async (payload) => {
  console.log(payload.payload);
  let experimentId = payload.payload;

  return await fetch(`/mick/experiments/${experimentId}/uploads/remove`, {
    method: "delete",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* removeKitUploadedData(payload) {
  // payload will contain the ID of the experiment
  console.log(payload);

  try {
    const response = yield call(removeKitUploadedDataRequest, payload);
    if (!response.includes("ERROR")) {
      yield put(removeKitUploadedDataSuccess(response));
    } else {
      yield put(removeKitUploadedDataError(response));
    }
  } catch (error) {
    yield put(removeKitUploadedDataError(error));
  }
}

//* EDIT KIT RESULTS TAKE ACTION // -----------------------------------------------------

const editKitResultsTakeActionItemRequest = async (payload) => {
  console.log("inside editKitResultsTakeActionItemRequest");
  console.log(payload);

  var {
    language,
    experimentId,
    takeActionMain,
    takeActionDiet,
    takeActionSupplements,
    takeActionExercise,
    takeActionReferences,
    takeActionComments,
    restTakeActions,
    index,
  } = payload;

  var contentsObject = {
    main: takeActionMain,
    diet: takeActionDiet,
    supplements: takeActionSupplements,
    exercise: takeActionExercise,
    resultComment: takeActionComments,
    references: takeActionReferences,
  };

  // copy array
  var restContentObject = [...restTakeActions];

  // remove edited element
  var removeTakeActionFromArray = restContentObject.splice(index, 1);

  // stringify objects
  function getQueryStringObjectType(params) {
    return Object.keys(params)
      .map((k) => {
        // for arrays
        {
          /* if (Array.isArray(params[k])) {
            return `"${encodeURIComponent(k)}":[${k
              .map((val) => `"${encodeURIComponent(val)}"`)
              .join(",")}]`;
          }*/
        }

        // for common strings
        return `"${encodeURIComponent(k)}":"${encodeURIComponent(params[k])}"`;
      })
      .join(",");
  }

  // surround every stringified object with { }
  function envelopeQueryStringObject(object) {
    return object.map((obj) => `{${getQueryStringObjectType(obj)}}`).join(",");
  }

  var contentsObjectStringified = getQueryStringObjectType(contentsObject);
  var restContentObjectStringified =
    envelopeQueryStringObject(restContentObject);

  var body;
  // checking if there are more then 1 action cards (otherwise give error contents it's not a object, because there is comma after {${contentsObjectStringified}}   )
  if (restContentObjectStringified) {
    body = `experimentId=${experimentId}&contents=[{${contentsObjectStringified}}, ${restContentObjectStringified}]&lang=${language}`;
  } else {
    body = `experimentId=${experimentId}&contents=[{${contentsObjectStringified}}]&lang=${language}`;
  }

  console.log(body);

  return await fetch(`/mick/experiments/takeaction/`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* editKitResultsTakeActionItem(payload) {
  console.log(payload);
  try {
    const response = yield call(
      editKitResultsTakeActionItemRequest,
      payload.payload
    );
    //console.log(response);
    if (!response.includes("ERROR")) {
      yield put(editKitResultsTakeActionItemSuccess(response));
    } else {
      //console.log(response.status);
      yield put(editKitResultsTakeActionItemError(response));
    }
  } catch (error) {
    yield put(editKitResultsTakeActionItemError(error));
  }
}

//* EDIT KIT RESULTS COMMENTS // -----------------------------------------------------

const editKitResultsCommentsItemRequest = async (payload) => {
  console.log("inside editKitResultsCommentsItemRequest");
  console.log(payload);

  var { experimentId, resultComment } = payload;

  var formBodyGeneralData = {
    resultComment,
  };

  // stringify objects
  function getQueryStringObjectType(params) {
    return Object.keys(params)
      .map((k) => {
        // if found an array
        if (Array.isArray(params[k])) {
          return `"${encodeURIComponent(k)}":[${params[k]
            .map((val) => `"${encodeURIComponent(val)}"`)
            .join(",")}]`;
        }

        // if found a number or a boolean doesn't add brackets
        if (typeof params[k] == "number" || typeof params[k] == "boolean") {
          return `"${encodeURIComponent(k)}":${encodeURIComponent(params[k])}`;
        }
        // for common strings
        return `"${encodeURIComponent(k)}":"${encodeURIComponent(params[k])}"`;
      })
      .join(",");
  }

  formBodyGeneralData = getQueryStringObjectType(formBodyGeneralData);

  var body = `experimentId=${experimentId}&toBeModified={${formBodyGeneralData}}`;

  console.log(body);

  return await fetch(`/mick/experiments/modify/`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      //Accept: "application/x-www-form-urlencoded",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  })
    .then((response) => {
      //console.log(response);
      return response.text();
    })
    .then((response) => {
      //console.log(response);
      return response;
    });
};

function* editKitResultsCommentsItem(payload) {
  console.log(payload);
  try {
    const response = yield call(
      editKitResultsCommentsItemRequest,
      payload.payload
    );
    //console.log(response);
    if (!response.includes("ERROR")) {
      yield put(editKitResultsCommentsItemSuccess(response));
    } else {
      //console.log(response.status);
      yield put(editKitResultsCommentsItemError(response));
    }
  } catch (error) {
    yield put(editKitResultsCommentsItemError(error));
  }
}

//* REMOVE KIT RESULTS EDITED TAKE ACTION // -----------------------------------------------------
const removeKitResultsTakeActionItemRequest = async (payload) => {
  console.log(payload.payload);
  let { experimentId, language } = payload.payload;

  return await fetch(
    `/mick/experiments/${experimentId}/takeaction/remove?lang=${language}`,
    {
      method: "delete",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Origin": "https://35.189.226.137",
      },
    }
  )
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* removeKitResultsTakeActionItem(payload) {
  // payload will contain the ID of the experiment
  console.log(payload);

  try {
    const response = yield call(removeKitResultsTakeActionItemRequest, payload);
    if (!response.includes("ERROR")) {
      yield put(removeKitResultsTakeActionItemSuccess(response));
    } else {
      yield put(removeKitResultsTakeActionItemError(response));
    }
  } catch (error) {
    yield put(removeKitResultsTakeActionItemError(error));
  }
}

//* GET REPORT LOGO  ---------------------------------------------------------------------------
const getReportLogoRequest = async (payload) => {
  let username = payload.payload;

  return await fetch(`/mick/experiments/report/logo`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  }).then((data) => {
    console.log(data);
    return data;
  });
};

function* getReportLogo(payload) {
  console.log(payload);
  try {
    const response = yield call(getReportLogoRequest, payload);

    if (response.ok) {
      yield put(getReportLogoSuccess(response.url));
    } else {
      yield put(getReportLogoSuccess(""));
    }
  } catch (error) {
    yield put(getReportLogoError(error));
  }
}

//* EDIT REPORT LOGO  -----------------------------------------------------------------------------
const editReportLogoRequest = async (payload) => {
  const formData = payload.payload;
  console.log(formData);

  return await fetch(`/mick/upload/logo`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      //"Access-Control-Allow-Origin": "https://35.189.226.137"
      // https://muffinman.io/uploading-files-using-fetch-multipart-form-data/
      // Remove 'Content-Type' header to allow browser to add
      // along with the correct 'boundary'
      // "Content-Type": "multipart/form-data"
    },

    body: formData,
  }).then((response) => {
    console.log(response);
    if (response.ok) {
      return response;
    } else {
      return response.text();
    }
  });
};

function* editReportLogoItem(payload) {
  console.log(payload);
  try {
    const response = yield call(editReportLogoRequest, payload);
    console.log(response);
    if (response.ok) {
      console.log("success logo saga");
      yield put(editReportLogoItemSuccess(response.statusText));
    } else {
      console.log(response);
      yield put(editReportLogoItemError(response));
    }
  } catch (error) {
    yield put(editReportLogoItemError(error));
  }
}

//* CLEAR KIT DATA // ---------------------------------------------------------------------------------------------

function clearKitData({ payload }) {
  const { history } = payload;
}

//* CLEAR KITS LIST DATA of the PATIENT // ---------------------------------------------------------------------------------------------

function clearKitsPatientListData({ payload }) {
  const { history } = payload;
}

//* CLEAR KIT RESULT DATA of the PATIENT // ---------------------------------------------------------------------------------------------
function clearKitResultData({ payload }) {
  const { history } = payload;
}

//* CLEAR KITS RESULT TIMECOURSE DATA of the PATIENT // ---------------------------------------------------------------------------------------------
function clearKitsResultsTimecourseData({ payload }) {
  const { history } = payload;
}

//!2. Our watcher saga
// our watcher saga spawn a new task on each action

export function* watchGetListPerPatient() {
  yield takeEvery(KITS_BYPATIENT_GET_LIST, getKitsPerPatientList);
}

export function* watchGetlistByUser() {
  yield takeEvery(KITS_USER_GET_LIST, getKitsPerUserList);
}

export function* watchGetlistByDoctor() {
  yield takeEvery(KITS_BYDOCTOR_GET_LIST, getKitsByDoctorList);
}

export function* watchGetInfoKit() {
  yield takeEvery(KIT_GET_INFO, getKitInfo);
}

export function* watchAddKit() {
  yield takeEvery(KIT_ADD_ITEM, addKitItem);
}

export function* watchEditKit() {
  yield takeEvery(KIT_EDIT_ITEM, editKitItem);
}

export function* watchUnlockPlugin() {
  yield takeEvery(KIT_UNLOCK_PLUGIN_ITEM, unlockPluginItem);
}

export function* watchActivateKit() {
  yield takeEvery(KIT_ACTIVATE_ITEM, activateKitItem);
}

export function* watchGetResultsKit() {
  yield takeEvery(KIT_GET_RESULTS, getKitResults);
}

export function* watchGetResultsBehaviourKit() {
  yield takeEvery(KIT_GET_RESULTS_BEHAVIOUR, getKitResultsBehaviour);
}

export function* watchGetResultsBiomarkersKit() {
  yield takeEvery(KIT_GET_RESULTS_BIOMARKERS, getKitResultsBiomarkers);
}

export function* watchGetResultsTimecourseKits() {
  yield takeEvery(KITS_GET_RESULTS_TIMECOURSE, getKitsResultsTimecourse);
}

export function* watchRemoveKit() {
  yield takeEvery(KIT_REMOVE_ITEM, removeKitItem);
}

export function* watchGetUploadedDataKit() {
  yield takeEvery(KIT_GET_UPLOADED_DATA, getKitUploadedData);
}
export function* watchRemoveUploadedDataKit() {
  yield takeEvery(KIT_REMOVE_UPLOADED_DATA, removeKitUploadedData);
}

export function* watchEditKitResultsTakeAction() {
  yield takeEvery(KIT_TAKEACTION_EDIT_ITEM, editKitResultsTakeActionItem);
}

export function* watchEditKitResultsComments() {
  yield takeEvery(KIT_RESULTS_COMMENTS_EDIT_ITEM, editKitResultsCommentsItem);
}

export function* watchRemoveKitResultsTakeAction() {
  yield takeEvery(KIT_TAKEACTION_REMOVE_ITEM, removeKitResultsTakeActionItem);
}

export function* watchGetReportLogo() {
  yield takeEvery(KIT_REPORT_GET_LOGO, getReportLogo);
}

export function* watchEditReportLogo() {
  yield takeEvery(KIT_REPORT_EDIT_LOGO, editReportLogoItem);
}

export function* watchClearKitData() {
  yield takeEvery(KIT_CLEAR_DATA, clearKitData);
}

export function* watchClearKitsPatientListData() {
  yield takeEvery(KITS_BYPATIENT_LIST_CLEAR_DATA, clearKitsPatientListData);
}

export function* watchClearKitResultData() {
  yield takeEvery(KITS_RESULTS_CLEAR_DATA, clearKitResultData);
}

export function* watchClearKitsResultsTimecourseData() {
  yield takeEvery(
    KITS_RESULTS_TIMECOURSE_CLEAR_DATA,
    clearKitsResultsTimecourseData
  );
}

//!3. Our root saga
// single entry point to start sagas at once

export default function* rootSaga() {
  yield all([
    fork(watchGetListPerPatient),
    fork(watchGetlistByUser),
    fork(watchGetlistByDoctor),
    fork(watchGetInfoKit),
    fork(watchAddKit),
    fork(watchEditKit),
    fork(watchUnlockPlugin),
    fork(watchActivateKit),
    fork(watchGetResultsKit),
    fork(watchGetResultsBehaviourKit),
    fork(watchGetResultsBiomarkersKit),
    fork(watchGetResultsTimecourseKits),
    fork(watchRemoveKit),
    fork(watchGetUploadedDataKit),
    fork(watchRemoveUploadedDataKit),
    fork(watchEditKitResultsTakeAction),
    fork(watchEditKitResultsComments),
    fork(watchRemoveKitResultsTakeAction),
    fork(watchGetReportLogo),
    fork(watchEditReportLogo),
    fork(watchClearKitData),
    fork(watchClearKitsPatientListData),
    fork(watchClearKitResultData),
    fork(watchClearKitsResultsTimecourseData),
  ]);
}
